module.exports = __webpack_public_path__ + "img/jxk_qhdx.90bc538a.svg";